import React, { Component } from "react";
import LoginScreen from "../screens/LoginScreen";
import MainContainer from "./MainContainer";
import { connect } from "react-redux";
import { setPage } from "../actions/navigation";
import { setCases } from "../actions/cases";
import "../assets/css/Fonts.css";

var dateFormat = require("dateformat");
var heute = new Date();
var rawheute = heute.getTime() / (1000 * 3600 * 24);
var fheute = Math.floor(rawheute);
var ff = fheute - 22;
var ein = ff * 1000 * 3600 * 24;
var eindat = dateFormat(ein, "mmmm dd yyyy");

class AppContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loggeddIn: false
    };
  }

  componentDidMount() {
    this.checkLoggedIn();
    this.props.setCases({
      0: [
        {
          kind: true,
          id: "9088-512",
          name: {
            value: "DreDag GmbH",
            confirmed: 1
          },
          contact: "Herbert Recht",
          state: "Rechnung prüfen",
          mvo: {
            value: "ja",
            confirmed: 0
          },
          vorsteuer: {
            value: "ja",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 830.6
          },
          sumf: {
            name: "Eingangsdatum",
            value: "January 05 2020"
          },

          sumv: {
            name: "Vorsteuerbetrag",
            value: 132.62
          },
          banking: {
            value: "DE29 5001 0517 3887 5113 53",
            confirmed: 1
          },
          address: {
            value: "Auf der Höhe, Dresden",
            confirmed: 1
          },
          phone: {
            value: "+49 189 91823",
            confirmed: 1
          },
          email: {
            value: "recht@dredag.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 9865 568",
            confirmed: 1
          },
          fax: {
            value: "+49 969 23546",
            confirmed: 0
          },
          logs: [
            {
              date: "01.06.2018",
              status: "fachlich richtig",
              state: "Ratenplan",
              worker: "M. Müller",
              action: "Gescheitert",
              money: "830",
              change: "•"
            },
            {
              date: "15.03.2018",
              status: "fachlich richtig",
              state: "Ratenplan",
              worker: "M. Müller",
              action: "Eingereicht",
              money: "830",
              change: "•"
            },
            {
              date: "20.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Telefon",
              money: "830",
              change: "40"
            },
            {
              date: "05.01.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Telefon",
              money: "870",
              change: "•"
            }
          ],
          belege: [
            {
              name: "Rechnung 1737",
              due: "10.11.2019",
              money: "90,00"
            },
            {
              name: "Anlage 1",
              due: "10.11.2019",
              money: ""
            }
          ],
          notes: [
            {
              date: "15.03.2018",
              value: "Rechnungsprüfung erforderlich"
            }
          ],
          stats: {
            inkasso: {
              value: "788",
              perc: "95"
            },
            fee: {
              value: "12",
              perc: "1,5"
            },
            zinsen: {
              value: "16.61",
              perc: "2"
            },
            total: {
              value: "830",
              perc: "100"
            }
          },
          overdue: 2
        },
        {
          kind: true,
          id: "246227-6",
          name: {
            value: "ImbissEcke UG",
            confirmed: 1
          },
          contact: "Peter Reichard",
          state: "Rechnung prüfen",
          mvo: {
            value: "ja",
            confirmed: 0
          },
          vorsteuer: {
            value: "nein",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 12430.6
          },
          sumf: {
            name: "Eingangsdatum",
            value: "Jan 20 2020"
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 1984.72
          },
          banking: {
            value: "DE29 5001 0517 3887 5113 53",
            confirmed: 1
          },
          address: {
            value: "Zankerstraße 17a, Dresden",
            confirmed: 1
          },
          phone: {
            value: "+49 1892 712",
            confirmed: -1
          },
          email: {
            value: "peter@imbiss-ecke.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 94934 48",
            confirmed: 1
          },
          fax: {
            value: "",
            confirmed: 0
          },
          logs: [
            {
              date: "25.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900",
              change: "300"
            },
            {
              date: "01.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200",
              change: "•"
            }
          ],
          belege: [
            {
              name: "Rechnung 1422",
              due: "21.02.2018",
              money: "185,00"
            },
            {
              name: "Rechnung 2484",
              due: "25.02.2018",
              money: "200,00"
            },
            {
              name: "Rechnung 4272",
              due: "14.02.2018",
              money: "1.800,00"
            }
          ],
          notes: [
            {
              date: "29.02.2018",
              value: "Rechnungsprüfung erforderlich"
            }
          ],
          stats: {
            inkasso: {
              value: "2.185",
              perc: "95"
            },
            fee: {
              value: "30",
              perc: "1,68"
            },
            zinsen: {
              value: "248.61",
              perc: "2"
            },
            total: {
              value: "2.300",
              perc: "100"
            }
          },
          overdue: 26
        }
      ],
      1: [
        {
          kind: true,
          id: "13454-6",
          name: {
            value: "Red Print UG",
            confirmed: 1
          },
          contact: "Richard David",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "nein",
            confirmed: 0
          },
          vorsteuer: {
            value: "nein",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 81
          },
          sumf: {
            name: "Eingangsdatum",
            value: "Jan 20 2020"
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 12
          },
          banking: {
            value: "DE90 5001 0517 1789 4465 24",
            confirmed: 1
          },
          address: {
            value: "Hochschulstraße 15, 01069 Dresden",
            confirmed: 1
          },
          phone: {
            value: "+49 12 15175",
            confirmed: -1
          },
          email: {
            value: "richard@red-printing.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 187 81284 12",
            confirmed: 1
          },
          fax: {
            value: "+49 12 125415",
            confirmed: -1
          },
          logs: [
            {
              date: "12.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "11.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 1521",
              due: "10.11.2019",
              money: "451,00"
            },
            {
              name: "Rechnung 75633",
              due: "10.11.2019",
              money: "1.000,00"
            },
            {
              name: "Rechnung 53863",
              due: "10.11.2019",
              money: "1.000,00"
            },
            {
              name: "Rechnung 36583",
              due: "10.11.2019",
              money: "2.000,00"
            }
          ],
          notes: [
            {
              date: "11.03.2018",
              value: "Mehrmals versucht anzurufen, morgen letzter Versuch"
            }
          ],
          stats: {
            inkasso: {
              value: "4.451",
              perc: "95"
            },
            fee: {
              value: "63",
              perc: "1,33"
            },
            zinsen: {
              value: "1.62",
              perc: "2"
            },
            total: {
              value: "4.791",
              perc: "100"
            }
          }
        },
        {
          kind: true,
          id: "39049-2",
          name: {
            value: "Kaiser GmbH",
            confirmed: 1
          },
          contact: "Rupert Meyer",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "ja",
            confirmed: 0
          },
          vorsteuer: {
            value: "ja",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 124.2
          },
          sumf: {
            name: "Eingangsdatum",
            value: "Feb 05 2020"
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 32.52
          },
          banking: {
            value: "DE50 5001 0517 1156 8917 17",
            confirmed: 1
          },
          address: {
            value: "Langford Straße 6 49490 Berlin",
            confirmed: 1
          },
          phone: {
            value: "+49 30 5820 097",
            confirmed: -1
          },
          email: {
            value: "r.meyer@kaiser.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 176 9201 3088",
            confirmed: 0
          },
          fax: {
            value: "+49 30 7773 020",
            confirmed: 1
          },
          logs: [
            {
              date: "25.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "01.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 918275",
              due: "10.11.2019",
              money: "300,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "605,00"
            }
          ],
          notes: [
            {
              date: "14.03.2018",
              value: "Telefonnummer nicht mehr aktuell"
            }
          ],
          stats: {
            inkasso: {
              value: "905",
              perc: "95"
            },
            fee: {
              value: "16",
              perc: "1,68"
            },
            zinsen: {
              value: "2.48",
              perc: "2"
            },
            total: {
              value: "953",
              perc: "100"
            }
          }
        },
        {
          kind: true,
          id: "32468-2",
          name: {
            value: "CloudHosting UG",
            confirmed: 1
          },
          contact: "Stefan Irving",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "ja",
            confirmed: 0
          },
          vorsteuer: {
            value: "nein",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 284.2
          },
          sumf: {
            name: "Eingangsdatum",
            value: "Feb 06 2020"
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 101.11
          },
          banking: {
            value: "DE61 5001 0517 5629 4942 98",
            confirmed: 1
          },
          address: {
            value: "Rochenplatz 7. 01565 Dresden",
            confirmed: 1
          },
          phone: {
            value: "+49 30 5820 097",
            confirmed: -1
          },
          email: {
            value: "iriving@CloudHosting.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 176 9201 3088",
            confirmed: 0
          },
          fax: {
            value: "+49 30 7773 020",
            confirmed: 0
          },
          logs: [
            {
              date: "25.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "01.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 918275",
              due: "10.11.2019",
              money: "400,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "1.500,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "1.500,00"
            }
          ],
          notes: [
            {
              date: "",
              value: ""
            }
          ],
          stats: {
            inkasso: {
              value: "3.400",
              perc: "95"
            },
            fee: {
              value: "60",
              perc: "1,68"
            },
            zinsen: {
              value: "5.68",
              perc: "2"
            },
            total: {
              value: "3.579",
              perc: "100"
            }
          }
        }
      ],
      2: [
        {
          kind: true,
          id: "39049-2",
          name: {
            value: "Kaiser GmbH",
            confirmed: 1
          },
          contact: "Rupert Meyer",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "nein",
            confirmed: 0
          },
          vorsteuer: {
            value: "nein",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 8888
          },
          sumf: {
            name: "Eingangsdatum",
            value: heute
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 3333
          },
          banking: {
            value: "DE63 5001 0517 7456 4778 16",
            confirmed: 1
          },
          address: {
            value: "Langford Straße 6 49490 Berlin",
            confirmed: 1
          },
          phone: {
            value: "+49 30 5820 097",
            confirmed: -1
          },
          email: {
            value: "r.meyer@kaiser.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 176 9201 3088",
            confirmed: 0
          },
          fax: {
            value: "+49 30 7773 020",
            confirmed: 0
          },
          logs: [
            {
              date: "25.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "01.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 918275",
              due: "10.11.2019",
              money: "700,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "560,00"
            }
          ],
          notes: [
            {
              date: "11.03.2018",
              value: "Mehrmals versucht anzurufen, morgen letzter Versuch"
            }
          ],
          stats: {
            inkasso: {
              value: "3.400",
              perc: "95"
            },
            fee: {
              value: "60",
              perc: "1,68"
            },
            zinsen: {
              value: "2",
              perc: "3"
            },
            total: {
              value: "899",
              perc: "100"
            }
          }
        },
        {
          kind: true,
          id: "39049-2",
          name: {
            value: "Eiscafe Red UG",
            confirmed: 1
          },
          contact: "Rupert Meyer",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "nein",
            confirmed: 0
          },
          vorsteuer: {
            value: "ja",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 830.6
          },
          sumf: {
            name: "Eingangsdatum",
            value: heute
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 132.52
          },
          banking: {
            value: "DE44 5001 0517 6192 6161 73",
            confirmed: 1
          },
          address: {
            value: "Langford Straße 6 49490 Berlin",
            confirmed: 1
          },
          phone: {
            value: "+49 30 5820 097",
            confirmed: -1
          },
          email: {
            value: "r.meyer@kaiser.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 176 9201 3088",
            confirmed: 0
          },
          fax: {
            value: "+49 30 7773 020",
            confirmed: 0
          },
          logs: [
            {
              date: "25.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "01.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 918275",
              due: "10.11.2019",
              money: "700,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "560,00"
            }
          ],
          notes: [
            {
              date: "11.03.2018",
              value: "Mehrmals versucht anzurufen, morgen letzter Versuch"
            }
          ],
          stats: {
            inkasso: {
              value: "3.400",
              perc: "95"
            },
            fee: {
              value: "60",
              perc: "1,68"
            },
            zinsen: {
              value: "119",
              perc: "2"
            },
            total: {
              value: "1.312",
              perc: "100"
            }
          }
        },
        {
          kind: true,
          id: "39049-2",
          name: {
            value: "Rechts Tat UG",
            confirmed: 1
          },
          contact: "Rupert Meyer",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "ja",
            confirmed: 0
          },
          vorsteuer: {
            value: "ja",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 800.01
          },
          sumf: {
            name: "Eingangsdatum",
            value: heute
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 123.1
          },
          banking: {
            value: "DE17 5001 0517 8739 5166 56",
            confirmed: 1
          },
          address: {
            value: "Langford Straße 6 49490 Berlin",
            confirmed: 1
          },
          phone: {
            value: "+49 30 5820 097",
            confirmed: -1
          },
          email: {
            value: "r.meyer@kaiser.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 176 9201 3088",
            confirmed: 0
          },
          fax: {
            value: "+49 30 7773 020",
            confirmed: 0
          },
          logs: [
            {
              date: "25.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "01.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 918275",
              due: "10.11.2019",
              money: "700,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "560,00"
            }
          ],
          notes: [
            {
              date: "11.03.2018",
              value: "Mehrmals versucht anzurufen, morgen letzter Versuch"
            }
          ],
          stats: {
            inkasso: {
              value: "3.400",
              perc: "95"
            },
            fee: {
              value: "60",
              perc: "1,68"
            },
            zinsen: {
              value: "119",
              perc: "2"
            },
            total: {
              value: "4.212",
              perc: "100"
            }
          }
        },
        {
          kind: true,
          id: "39049-2",
          name: {
            value: "Ritter Denkspiel",
            confirmed: 1
          },
          contact: "Rupert Meyer",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "nein",
            confirmed: 0
          },
          vorsteuer: {
            value: "ja",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 830.6
          },
          sumf: {
            name: "Eingangsdatum",
            value: heute
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 132.52
          },
          banking: {
            value: "DE34 5001 0517 5996 8472 67",
            confirmed: 1
          },
          address: {
            value: "Langford Straße 6 49490 Berlin",
            confirmed: 1
          },
          phone: {
            value: "+49 30 5820 097",
            confirmed: -1
          },
          email: {
            value: "r.meyer@kaiser.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 176 9201 3088",
            confirmed: 0
          },
          fax: {
            value: "+49 30 7773 020",
            confirmed: 0
          },
          logs: [
            {
              date: "25.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "01.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 918275",
              due: "10.11.2019",
              money: "700,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "560,00"
            }
          ],
          notes: [
            {
              date: "11.03.2018",
              value: "Mehrmals versucht anzurufen, morgen letzter Versuch"
            }
          ],
          stats: {
            inkasso: {
              value: "3.400",
              perc: "95"
            },
            fee: {
              value: "60",
              perc: "1,68"
            },
            zinsen: {
              value: "119",
              perc: "2"
            },
            total: {
              value: "254",
              perc: "100"
            }
          }
        },
        {
          kind: false,
          id: "39049-2",
          name: {
            value: "Dieter Sambal",
            confirmed: 1
          },
          contact: "Rupert Meyer",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "nein",
            confirmed: 0
          },
          vorsteuer: {
            value: "ja",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 830.6
          },
          sumf: {
            name: "Eingangsdatum",
            value: heute
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 132.52
          },
          banking: {
            value: "DE90 5001 0517 8447 3222 42",
            confirmed: 1
          },
          address: {
            value: "Langford Straße 6 49490 Berlin",
            confirmed: 1
          },
          phone: {
            value: "+49 30 5820 097",
            confirmed: -1
          },
          email: {
            value: "r.meyer@kaiser.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 176 9201 3088",
            confirmed: 0
          },
          fax: {
            value: "+49 30 7773 020",
            confirmed: 0
          },
          logs: [
            {
              date: "25.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "01.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 918275",
              due: "10.11.2019",
              money: "700,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "560,00"
            }
          ],
          notes: [
            {
              date: "11.03.2018",
              value: "Mehrmals versucht anzurufen, morgen letzter Versuch"
            }
          ],
          stats: {
            inkasso: {
              value: "3.400",
              perc: "95"
            },
            fee: {
              value: "60",
              perc: "1,68"
            },
            zinsen: {
              value: "119",
              perc: "2"
            },
            total: {
              value: "120",
              perc: "100"
            }
          }
        },
        {
          kind: false,
          id: "39049-2",
          name: {
            value: "Wolfgang Kaiser",
            confirmed: 1
          },
          contact: "Rupert Meyer",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "nein",
            confirmed: 0
          },
          vorsteuer: {
            value: "ja",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 830.6
          },
          sumf: {
            name: "Eingangsdatum",
            value: heute
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 132.52
          },
          banking: {
            value: "DE98 5001 0517 1835 2894 53",
            confirmed: 1
          },
          address: {
            value: "Langford Straße 6 49490 Berlin",
            confirmed: 1
          },
          phone: {
            value: "+49 30 5820 097",
            confirmed: -1
          },
          email: {
            value: "r.meyer@kaiser.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 176 9201 3088",
            confirmed: 0
          },
          fax: {
            value: "+49 30 7773 020",
            confirmed: 0
          },
          logs: [],
          belege: [],
          notes: [
            {
              date: "11.03.2018",
              value: "Mehrmals versucht anzurufen, morgen letzter Versuch"
            }
          ],
          stats: {
            inkasso: {
              value: "3.400",
              perc: "95"
            },
            fee: {
              value: "60",
              perc: "1,68"
            },
            zinsen: {
              value: "119",
              perc: "2"
            },
            total: {
              value: "211",
              perc: "100"
            }
          }
        },
        {
          kind: true,
          id: "39049-2",
          name: {
            value: "Pets Zoohandel",
            confirmed: 1
          },
          contact: "Rupert Meyer",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "nein",
            confirmed: 0
          },
          vorsteuer: {
            value: "nein",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 830.6
          },
          sumf: {
            name: "Eingangsdatum",
            value: heute
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 132.52
          },
          banking: {
            value: "DE44 5001 0517 9434 6177 82",
            confirmed: 1
          },
          address: {
            value: "Langford Straße 6 49490 Berlin",
            confirmed: 1
          },
          phone: {
            value: "+49 30 5820 097",
            confirmed: -1
          },
          email: {
            value: "r.meyer@kaiser.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 176 9201 3088",
            confirmed: 0
          },
          fax: {
            value: "+49 30 7773 020",
            confirmed: 0
          },
          logs: [
            {
              date: "25.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "01.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 918275",
              due: "10.11.2019",
              money: "700,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "560,00"
            }
          ],
          notes: [
            {
              date: "11.03.2018",
              value: "Mehrmals versucht anzurufen, morgen letzter Versuch"
            }
          ],
          stats: {
            inkasso: {
              value: "3.400",
              perc: "95"
            },
            fee: {
              value: "60",
              perc: "1,68"
            },
            zinsen: {
              value: "119",
              perc: "2"
            },
            total: {
              value: "920",
              perc: "100"
            }
          }
        }
      ],
      3: [
        {
          kind: true,
          id: "13454-6",
          name: {
            value: "Red Print UG",
            confirmed: 1
          },
          contact: "Richard David",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "nein",
            confirmed: 0
          },
          vorsteuer: {
            value: "nein",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 81
          },
          sumf: {
            name: "Eingangsdatum",
            value: eindat
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 12
          },
          banking: {
            value: "DE90 5001 0517 1789 4465 24",
            confirmed: 1
          },
          address: {
            value: "Hochschulstraße 15, 01069 Dresden",
            confirmed: 1
          },
          phone: {
            value: "+49 12 15175",
            confirmed: -1
          },
          email: {
            value: "richard@red-printing.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 187 81284 12",
            confirmed: 1
          },
          fax: {
            value: "+49 12 125415",
            confirmed: -1
          },
          logs: [
            {
              date: "12.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "11.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 1521",
              due: "10.11.2019",
              money: "451,00"
            },
            {
              name: "Rechnung 75633",
              due: "10.11.2019",
              money: "1.000,00"
            },
            {
              name: "Rechnung 53863",
              due: "10.11.2019",
              money: "1.000,00"
            },
            {
              name: "Rechnung 36583",
              due: "10.11.2019",
              money: "2.000,00"
            }
          ],
          notes: [
            {
              date: "11.03.2018",
              value: "Mehrmals versucht anzurufen, morgen letzter Versuch"
            }
          ],
          stats: {
            inkasso: {
              value: "4.451",
              perc: "95"
            },
            fee: {
              value: "63",
              perc: "1,33"
            },
            zinsen: {
              value: "175",
              perc: "2"
            },
            total: {
              value: "4.791",
              perc: "100"
            }
          }
        },
        {
          kind: true,
          id: "39049-2",
          name: {
            value: "Kaiser GmbH",
            confirmed: 1
          },
          contact: "Rupert Meyer",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "ja",
            confirmed: 0
          },
          vorsteuer: {
            value: "ja",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 124.2
          },
          sumf: {
            name: "Eingangsdatum",
            value: eindat
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 32.52
          },
          banking: {
            value: "DE50 5001 0517 1156 8917 17",
            confirmed: 1
          },
          address: {
            value: "Langford Straße 6 49490 Berlin",
            confirmed: 1
          },
          phone: {
            value: "+49 30 5820 097",
            confirmed: -1
          },
          email: {
            value: "r.meyer@kaiser.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 176 9201 3088",
            confirmed: 0
          },
          fax: {
            value: "+49 30 7773 020",
            confirmed: 1
          },
          logs: [
            {
              date: "25.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "01.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 918275",
              due: "10.11.2019",
              money: "300,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "605,00"
            }
          ],
          notes: [
            {
              date: "14.03.2018",
              value: "Telefonnummer nicht mehr aktuell"
            }
          ],
          stats: {
            inkasso: {
              value: "905",
              perc: "95"
            },
            fee: {
              value: "16",
              perc: "1,68"
            },
            zinsen: {
              value: "32",
              perc: "2"
            },
            total: {
              value: "953",
              perc: "100"
            }
          }
        },
        {
          kind: true,
          id: "32468-2",
          name: {
            value: "CloudHosting UG",
            confirmed: 1
          },
          contact: "Stefan Irving",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "ja",
            confirmed: 0
          },
          vorsteuer: {
            value: "nein",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 284.2
          },
          sumf: {
            name: "Eingangsdatum",
            value: eindat
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 101.11
          },
          banking: {
            value: "DE61 5001 0517 5294 942 98",
            confirmed: 1
          },
          address: {
            value: "Rochenplatz 7. 01565 Dresden",
            confirmed: 1
          },
          phone: {
            value: "+49 30 5820 097",
            confirmed: -1
          },
          email: {
            value: "iriving@CloudHosting.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 176 9201 3088",
            confirmed: 0
          },
          fax: {
            value: "+49 30 7773 020",
            confirmed: 0
          },
          logs: [
            {
              date: "25.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "01.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 918275",
              due: "10.11.2019",
              money: "400,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "1.500,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "1.500,00"
            }
          ],
          notes: [
            {
              date: "",
              value: ""
            }
          ],
          stats: {
            inkasso: {
              value: "3.400",
              perc: "95"
            },
            fee: {
              value: "60",
              perc: "1,68"
            },
            zinsen: {
              value: "119",
              perc: "2"
            },
            total: {
              value: "3.579",
              perc: "100"
            }
          }
        }
      ],
      4: [
        {
          kind: true,
          id: "13454-6",
          name: {
            value: "Red Print UG",
            confirmed: 1
          },
          contact: "Richard David",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "nein",
            confirmed: 0
          },
          vorsteuer: {
            value: "nein",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 81
          },
          sumf: {
            name: "Eingangsdatum",
            value: "Feb 06 2020"
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 12
          },
          banking: {
            value: "DE90 5001 0517 1789 4465 24",
            confirmed: 1
          },
          address: {
            value: "Hochschulstraße 15, 01069 Dresden",
            confirmed: 1
          },
          phone: {
            value: "+49 12 15175",
            confirmed: -1
          },
          email: {
            value: "richard@red-printing.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 187 81284 12",
            confirmed: 1
          },
          fax: {
            value: "+49 12 125415",
            confirmed: -1
          },
          logs: [
            {
              date: "12.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "11.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 1521",
              due: "10.11.2019",
              money: "451,00"
            },
            {
              name: "Rechnung 75633",
              due: "10.11.2019",
              money: "1.000,00"
            },
            {
              name: "Rechnung 53863",
              due: "10.11.2019",
              money: "1.000,00"
            },
            {
              name: "Rechnung 36583",
              due: "10.11.2019",
              money: "2.000,00"
            }
          ],
          notes: [
            {
              date: "11.03.2018",
              value: "Mehrmals versucht anzurufen, morgen letzter Versuch"
            }
          ],
          stats: {
            inkasso: {
              value: "4.451",
              perc: "95"
            },
            fee: {
              value: "63",
              perc: "1,33"
            },
            zinsen: {
              value: "175",
              perc: "2"
            },
            total: {
              value: "4.791",
              perc: "100"
            }
          }
        },
        {
          kind: true,
          id: "13454-6",
          name: {
            value: "Red Print UG",
            confirmed: 1
          },
          contact: "Richard David",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "nein",
            confirmed: 0
          },
          vorsteuer: {
            value: "nein",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 81
          },
          sumf: {
            name: "Eingangsdatum",
            value: "Feb 11 2020"
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 12
          },
          banking: {
            value: "DE90 5001 0517 1789 4465 24",
            confirmed: 1
          },
          address: {
            value: "Hochschulstraße 15, 01069 Dresden",
            confirmed: 1
          },
          phone: {
            value: "+49 12 15175",
            confirmed: -1
          },
          email: {
            value: "richard@red-printing.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 187 81284 12",
            confirmed: 1
          },
          fax: {
            value: "+49 12 125415",
            confirmed: -1
          },
          logs: [
            {
              date: "12.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "11.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 1521",
              due: "10.11.2019",
              money: "451,00"
            },
            {
              name: "Rechnung 75633",
              due: "10.11.2019",
              money: "1.000,00"
            },
            {
              name: "Rechnung 53863",
              due: "10.11.2019",
              money: "1.000,00"
            },
            {
              name: "Rechnung 36583",
              due: "10.11.2019",
              money: "2.000,00"
            }
          ],
          notes: [
            {
              date: "11.03.2018",
              value: "Mehrmals versucht anzurufen, morgen letzter Versuch"
            }
          ],
          stats: {
            inkasso: {
              value: "4.451",
              perc: "95"
            },
            fee: {
              value: "63",
              perc: "1,33"
            },
            zinsen: {
              value: "175",
              perc: "2"
            },
            total: {
              value: "4.791",
              perc: "100"
            }
          }
        },
        {
          kind: true,
          id: "13454-6",
          name: {
            value: "Red Print UG",
            confirmed: 1
          },
          contact: "Richard David",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "nein",
            confirmed: 0
          },
          vorsteuer: {
            value: "nein",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 81
          },
          sumf: {
            name: "Eingangsdatum",
            value: "Feb 05 2020"
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 12
          },
          banking: {
            value: "DE90 5001 0517 1789 4465 24",
            confirmed: 1
          },
          address: {
            value: "Hochschulstraße 15, 01069 Dresden",
            confirmed: 1
          },
          phone: {
            value: "+49 12 15175",
            confirmed: -1
          },
          email: {
            value: "richard@red-printing.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 187 81284 12",
            confirmed: 1
          },
          fax: {
            value: "+49 12 125415",
            confirmed: -1
          },
          logs: [
            {
              date: "12.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "11.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 1521",
              due: "10.11.2019",
              money: "451,00"
            },
            {
              name: "Rechnung 75633",
              due: "10.11.2019",
              money: "1.000,00"
            },
            {
              name: "Rechnung 53863",
              due: "10.11.2019",
              money: "1.000,00"
            },
            {
              name: "Rechnung 36583",
              due: "10.11.2019",
              money: "2.000,00"
            }
          ],
          notes: [
            {
              date: "11.03.2018",
              value: "Mehrmals versucht anzurufen, morgen letzter Versuch"
            }
          ],
          stats: {
            inkasso: {
              value: "4.451",
              perc: "95"
            },
            fee: {
              value: "63",
              perc: "1,33"
            },
            zinsen: {
              value: "175",
              perc: "2"
            },
            total: {
              value: "4.791",
              perc: "100"
            }
          }
        },
        {
          kind: true,
          id: "13454-6",
          name: {
            value: "Red Print UG",
            confirmed: 1
          },
          contact: "Richard David",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "nein",
            confirmed: 0
          },
          vorsteuer: {
            value: "nein",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 81
          },
          sumf: {
            name: "Eingangsdatum",
            value: "Feb 05 2020"
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 12
          },
          banking: {
            value: "DE90 5001 0517 1789 4465 24",
            confirmed: 1
          },
          address: {
            value: "Hochschulstraße 15, 01069 Dresden",
            confirmed: 1
          },
          phone: {
            value: "+49 12 15175",
            confirmed: -1
          },
          email: {
            value: "richard@red-printing.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 187 81284 12",
            confirmed: 1
          },
          fax: {
            value: "+49 12 125415",
            confirmed: -1
          },
          logs: [
            {
              date: "12.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "11.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 1521",
              due: "10.11.2019",
              money: "451,00"
            },
            {
              name: "Rechnung 75633",
              due: "10.11.2019",
              money: "1.000,00"
            },
            {
              name: "Rechnung 53863",
              due: "10.11.2019",
              money: "1.000,00"
            },
            {
              name: "Rechnung 36583",
              due: "10.11.2019",
              money: "2.000,00"
            }
          ],
          notes: [
            {
              date: "11.03.2018",
              value: "Mehrmals versucht anzurufen, morgen letzter Versuch"
            }
          ],
          stats: {
            inkasso: {
              value: "4.451",
              perc: "95"
            },
            fee: {
              value: "63",
              perc: "1,33"
            },
            zinsen: {
              value: "175",
              perc: "2"
            },
            total: {
              value: "4.791",
              perc: "100"
            }
          }
        },
        {
          kind: true,
          id: "39049-2",
          name: {
            value: "Kaiser GmbH",
            confirmed: 1
          },
          contact: "Rupert Meyer",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "ja",
            confirmed: 0
          },
          vorsteuer: {
            value: "ja",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 124.2
          },
          sumf: {
            name: "Eingangsdatum",
            value: "Feb 05 2020"
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 32.52
          },
          banking: {
            value: "DE50 5001 0517 1156 8917 17",
            confirmed: 1
          },
          address: {
            value: "Langford Straße 6 49490 Berlin",
            confirmed: 1
          },
          phone: {
            value: "+49 30 5820 097",
            confirmed: -1
          },
          email: {
            value: "r.meyer@kaiser.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 176 9201 3088",
            confirmed: 0
          },
          fax: {
            value: "+49 30 7773 020",
            confirmed: 1
          },
          logs: [
            {
              date: "25.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "01.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 918275",
              due: "10.11.2019",
              money: "300,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "605,00"
            }
          ],
          notes: [
            {
              date: "14.03.2018",
              value: "Telefonnummer nicht mehr aktuell"
            }
          ],
          stats: {
            inkasso: {
              value: "905",
              perc: "95"
            },
            fee: {
              value: "16",
              perc: "1,68"
            },
            zinsen: {
              value: "32",
              perc: "2"
            },
            total: {
              value: "953",
              perc: "100"
            }
          }
        },
        {
          kind: true,
          id: "32468-2",
          name: {
            value: "CloudHosting UG",
            confirmed: 1
          },
          contact: "Stefan Irving",
          overdue: 26,
          state: "Zahlungsaufforderung",
          mvo: {
            value: "ja",
            confirmed: 0
          },
          vorsteuer: {
            value: "nein",
            confirmed: 0
          },
          sumb: {
            name: "Buchungsstelle",
            value: "15 03/812 99"
          },
          sumg: {
            name: "Anordnungsbetrag",
            value: 284.2
          },
          sumf: {
            name: "Eingangsdatum",
            value: "Feb 05 2020"
          },
          sumv: {
            name: "Vorsteuerbetrag",
            value: 101.11
          },
          banking: {
            value: "DE61 5001 0517 5629 4942 98",
            confirmed: 1
          },
          address: {
            value: "Rochenplatz 7. 01565 Dresden",
            confirmed: 1
          },
          phone: {
            value: "+49 30 5820 097",
            confirmed: -1
          },
          email: {
            value: "iriving@CloudHosting.de",
            confirmed: 1
          },
          mobile: {
            value: "+49 176 9201 3088",
            confirmed: 0
          },
          fax: {
            value: "+49 30 7773 020",
            confirmed: 0
          },
          logs: [
            {
              date: "25.02.2018",
              status: "fachlich richtig",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "3.900"
            },
            {
              date: "01.02.2018",
              status: "Erstbuchung",
              state: "Zahlungsaufforderung",
              worker: "M. Müller",
              action: "Email",
              money: "4.200"
            }
          ],
          belege: [
            {
              name: "Rechnung 918275",
              due: "10.11.2019",
              money: "400,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "1.500,00"
            },
            {
              name: "Rechnung 12984",
              due: "10.11.2019",
              money: "1.500,00"
            }
          ],
          notes: [
            {
              date: "",
              value: ""
            }
          ],
          stats: {
            inkasso: {
              value: "3.400",
              perc: "95"
            },
            fee: {
              value: "60",
              perc: "1,68"
            },
            zinsen: {
              value: "119",
              perc: "2"
            },
            total: {
              value: "3.579",
              perc: "100"
            }
          }
        }
      ]
    });
  }

  checkLoggedIn() {
    if (sessionStorage.getItem("user")) this.setState({ loggedIn: true });
  }

  login(username, password) {
    if (false || (username === "test" && password === "test")) {
      this.setState({ loggedIn: true });
      sessionStorage.setItem("user", true);
    }
  }

  logout() {
    sessionStorage.removeItem("user");
    this.setState({ loggedIn: false });
  }

  render() {
    if (!this.state.loggedIn) {
      return <LoginScreen login={this.login.bind(this)} />;
    } else {
      return <MainContainer logout={this.logout.bind(this)} />;
    }
  }
}

const mapStateToProps = state => {
  return {
    page: state.currentPage,
    cases: state.cases
  };
};

const mapDispatchToProps = dispatch => ({
  setPage: page => dispatch(setPage(page)),
  setCases: cases => {
    dispatch(setCases(cases));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);



// WEBPACK FOOTER //
// ./src/container/AppContainer.js